import { SingleSpouseType, SpouseType } from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { Spouse, Spouses } from 'service/dto/spouse.dto';
import { errorHandler } from 'utils';

class SpouseService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createSpouse = async (spouseType: SpouseType) => {
    try {
      const response = await this.baseService.post(
        '/spouse/create',
        spouseType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  updateSpouse = async (spouse: SingleSpouseType, spouseId: number | null) => {
    try {
      const response = await this.baseService.put(
        `/spouse/${spouseId}`,
        spouse
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
  checkIfEmailInUse = async (email: string) => {
    const response = await this.baseService.get(
      `/spouse/email-exists/${email}`
    );
    return response.data;
  };

  getSpouses = async (search?: string | undefined): Promise<Spouses> => {
    try {
      const response = await this.baseService.get(`/spouse?search=${search}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteSpouse = async (spouseId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(`/spouse/${spouseId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getSpouse = async (spouseId: number): Promise<Spouse> => {
    try {
      const response = await this.baseService.get(`/spouse/${spouseId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default SpouseService;
